<table aria-label="Contained Pieces" mat-table [dataSource]="otherPieces" class="pieces-table">
  <ng-container matColumnDef="id">
    <th scope="col" mat-header-cell *matHeaderCellDef> Id </th>
    <td mat-cell *matCellDef="let piece"> {{piece.idAbbrev}} </td>
  </ng-container>

  <ng-container matColumnDef="dimension">
    <th scope="col" mat-header-cell *matHeaderCellDef> Dimension </th>
    <td mat-cell *matCellDef="let piece"> {{piece.dimension}} </td>
  </ng-container>

  <ng-container matColumnDef="volume">
    <th scope="col" mat-header-cell *matHeaderCellDef> Volume </th>
    <td mat-cell *matCellDef="let piece"> {{piece.volume}} </td>
  </ng-container>
  <ng-container matColumnDef="weight">
    <th scope="col" mat-header-cell *matHeaderCellDef> Weight </th>
    <td mat-cell *matCellDef="let piece"> {{piece.weight}} </td>
  </ng-container>
  <ng-container matColumnDef="chargeableWeight">
    <th scope="col" mat-header-cell *matHeaderCellDef> charg. Weight </th>
    <td mat-cell *matCellDef="let piece"> {{piece.chargeableWeight}} </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr class="piece-row" mat-row *matRowDef="let row; columns: displayedColumns;" (click)="click(row)"></tr>
</table>